import { gql } from "apollo-angular";

const GET_CATEGORIES = gql`
  query getCategories($organizationId: Long!){
    primaryCategories (
        organizationId: $organizationId
    ) {
        id,
        name,
        statistic {
          expiredRfpCount,
          inFlightRfpCount,
        },
        actualSpend ,
        potentialSavings{
          savingsVolume,
          savingsAlertLevel,
          groupSavingsVolume,
          groupSavingsAlertLevel
        },
        categorizationScheme {
          id,
          name
        },
        parents {
          id,
          name,
          level
        },
        alerts
      }
  }
`;

export default GET_CATEGORIES;